var Marionette = require('backbone.marionette');

var EntitiesSelectView = require('../entities/entities-select');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var PermissionModel = require('../../models/permission-model');
var EntitiesCollection = require('../../collections/entities-collection');
var RolesCollection = require('../../collections/roles-collection');

var PermissionFormView = Marionette.View.extend({
    template: require('../../templates/permissions/permission-form.html'),

    regions: {
        owners: "#owners-container",
        organization: '#orgs-container',
        permissionsTemplates: '#permission-templates-list'
    },

    model: new PermissionModel(),

    childViewEvents: {
        'entity:selected': 'entitySelected',
        'suggestor:selected:person': 'personChanged',
        'suggestor:selected:organization': 'organizationChanged'
    },

    events: {
        'click #save-permission': 'addPermission',
        'change #can-read': 'onChecked',
        'change #can-write': 'onChecked',
        'change #can-write-for': 'onChecked',
        'change #can-delete': 'onChecked',
        'change #can-sign': 'onChecked',
        'change #can-sign-all': 'onChecked',
        'change #can-upload-for': 'onChecked',
        'change #can-read-for': 'onChecked',
        'change #can-read-all': 'onChecked',
        'change #can-change-reviewer': 'onChecked',
        'change #can-edit-all': 'onChecked'
    },

    ui: {
        saveBtn: '#save-permission'
    },

    showOrganization: false,

    constants: {
        maxNumberOfItemsInControlWithSuggester: 20
    },

    templateContext: function () {
        return {
            showOrganization: this.showOrganization,
            permittedObjectType: this.permittedObjectType
        };
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(this, 'onRender', 'entitySelected', 'addPermission',
            'afterUpdate', 'onChecked', 'fillModelFromPermissionTemplate', 'renderPersonSelectView', 'renderOrganizationSelectView');
        if (options) {
            that.permittedObjectId = options.permittedObjectId;
            if (options.showOrganization)
                that.showOrganization = options.showOrganization;
            that.permittedObjectType = options.permittedObjectType;
        }
        that.model.view = that;
        that.model.bind("validated", that.validated);

        that.permissionTypesCollection = new RolesCollection([], {
            params: [
                {key: 'sortby', value: 'templateName'},
                {key: 'sortdir', value: 'ASC'},
                {key: 'templateType', value: that.permittedObjectType}
            ]
        });
    },

    validated: function (valid) {
        var saveBtn = this.view.ui.saveBtn;
        if (valid) {
            saveBtn.removeAttr("disabled");
        } else {
            saveBtn.attr("disabled", "true");
        }
    },

    onRender: function () {
        var that = this;
        that.renderPersonSelectView();

        if (that.showOrganization) {
            that.renderOrganizationSelectView();
        }

        that.initiateStates();
        that.model.set('permittedObjectId', that.permittedObjectId);

        that.permissionTypesCollection.fetch({
            success: function () {
                that.permissionTemplatesSelectView = new EntitiesSelectView({
                    entityType: 'permissionTemplate',
                    customPlaceholder: 'Select a permission template',
                    collectionValues: new EntitiesCollection(that.permissionTypesCollection.map(function (elem) {
                        return {
                            id: elem.get('id'),
                            name: elem.get('templateName')
                        }
                    }))
                });
                that.showChildView('permissionsTemplates', that.permissionTemplatesSelectView);
            }
        });


        // $('.tooltipable').each(function () {
        //     $(this).tooltip();
        // })
    },

    renderPersonSelectView: function () {

        var that = this;

        that.showChildView('owners', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.mergeable === false;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select a person",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'person'
        }));
    },

    renderOrganizationSelectView: function () {
        var that = this;

        that.showChildView('organization', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select a organization",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'organization'
        }));
    },

    initiateStates: function () {
        this.model.set(this.model.defaults);
        this.ui.saveBtn.attr("disabled", "true");
    },

    entitySelected: function (data) {
        if (data.type == 'permissionTemplate') {
            var permissionTemplate = this.permissionTypesCollection.findWhere({id: data.id});
            if (typeof permissionTemplate != "undefined") {
                this.fillModelFromPermissionTemplate(permissionTemplate);
            }
        }
    },

    addPermission: function () {
        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
    },

    afterUpdate: function () {
        this.triggerMethod('permission:saved', this.model.clone());
        this.model.set(this.model.defaults);
        this.render();
    },

    onChecked: function (event) {
        this.model.set(event.target.value, event.target.checked);
    },

    fillModelFromPermissionTemplate: function (permissionTemplate) {
        var that = this;
        var booleanFields = Object.keys(permissionTemplate.attributes).filter(function (attr) {
            return attr.startsWith('can');
        });
        booleanFields.forEach(function (field) {
            var checkboxInput = that.$("input[value='" + field + "']");
            var value = permissionTemplate.get(field);
            if (value == true) {
                checkboxInput.prop('checked', true);
                that.model.set(field, true);
            } else {
                checkboxInput.prop('checked', false);
                that.model.set(field, false);
            }
        });
    },

    personChanged: function (id) {
        this.model.set('ownerId', id);
    },

    organizationChanged: function (id) {
        this.model.set('organizationId', id);
    }
});

module.exports = PermissionFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/permissions/permission-form.js
// module id = 243
// module chunks = 0